export default {
  orderBy: 'Order by',
  order: {
    relevance: 'Relevance',
    priceAsc: 'Price - Low to high',
    priceDesc: 'Price - High to low',
    title: 'Title',
  },
  filters: {
    title: 'Filters',
  },
  clear: 'Clear',
  clearAll: 'Clear all',
  category: {
    title: 'Category',
  },
  availability: {
    title: 'Availability',
    inStock: 'In stock',
  },
  showMore: 'Show more',
  taxesShipping: '+ taxes & shipping',
  showLess: 'Show less',
  facets: {
    price: 'Price',
    brands: 'Brands',
    seller: 'Seller',
  },
  price: {
    under: 'Under',
    andOver: 'and over',
  },
  input: {
    refine: 'Refine...',
  },
  checkprice: {
    apply: 'Apply',
    min: 'Min',
    max: 'Max',
    error: 'Invalid Max value !',
  },
  badges: { // Keep as short as possible
    verifiedSeller: 'Verified Seller',
    outOfStock: 'Out of stock',
    delivery: 'Delivery',
  },
  results: { // 123 Results for 'samsung'. (Corrected from 'sansung')
    results: 'Results',
    for: 'for',
    correctedFrom: 'Corrected from',
    filterResults: 'Filter results',
  },
}
